import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircle = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "M20.062 11.469c0-.266-.094-.531-.281-.719l-1.422-1.406c-.187-.187-.438-.297-.703-.297s-.516.109-.703.297l-6.375 6.359-3.531-3.531c-.187-.187-.438-.297-.703-.297s-.516.109-.703.297l-1.422 1.406c-.187.187-.281.453-.281.719s.094.516.281.703l5.656 5.656c.187.187.453.297.703.297.266 0 .531-.109.719-.297l8.484-8.484a.98.98 0 0 0 .281-.703M24 14c0 6.625-5.375 12-12 12S0 20.625 0 14 5.375 2 12 2s12 5.375 12 12"
  })
});
const Memo = /*#__PURE__*/memo(SvgCheckCircle);
export default Memo;